import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/boxes/"+id, form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/boxes");
  },
    
  async units() {
    await Csrf.getCookie();

    return Api.get("/units");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/boxes", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/boxes/" + id);      
      
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/boxes/" + id);      
      
  }, 
	
  async addLock(id,form) {
    await Csrf.getCookie();

    return Api.post("/boxes/" + id + '/add-lock',form);      
      
  },
	
  async deleteLock(id,form) {
    await Csrf.getCookie();

    return Api.post("/boxes/" + id + '/remove-lock',form);      
      
  },
};